* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 2px;
}

gz-labeled-content {
  margin-top: calc(var(--spacer) * 1);
}

gz-labeled-content::part(content) {
  display: flex;
  flex-direction: column;
  color: var(--main-titles-inputs-600);
  padding: var(--show-more-content-padding);
}

gz-labeled-content::part(label) {
  color: var(--show-more-label-color, var(--text-color-on-light-50));
}

gz-icon-label {
  padding-bottom: calc(var(--spacer) * 2 - 4px);
}

gz-icon-label {
  &:last-child {
    padding-bottom: var(--spacer);
  }
}

gz-icon-label[icon='icon-mail']::part(icon) {
  font-size: 11px;
}

gz-icon-label[icon='icon-User-Generic'],
gz-icon-label[icon='icon-User-Azure'],
gz-icon-label[icon='icon-User-Office365'],
gz-icon-label[icon='icon-Integration-Azure-AD'] {
  &::part(icon) {
    font-size: 18px;
  }
}

gz-icon-label[icon='icon-Launch-template'],
gz-icon-label[icon='icon-SSH'] {
  &::part(icon) {
    font-size: 13px;
  }
}

.resource-container,
.entities-container {
  &:last-of-type {
    height: 22px;
  }
  height: 30px;
}

.show-more-button {
  padding-top: calc(var(--spacer) / 2 - 1px);
  color: var(--blue-layout-400-primary);
  &:hover {
    color: var(--blue-layout-301-active);
  }
}

.container {
  &:first-of-type {
    margin-top: -8px;
  }
}
